function applyBackorder(picker) {
  const original = picker.updateAddToCartButton?.bind(picker);
  if (!original) return;

  picker.updateAddToCartButton = function () {
    original.apply(this, arguments);

    const btn = this.addBtn;
    const variant = this.variant;
    if (!btn || !variant) return;

    const formatted = this.data?.formatted?.[variant.id];
    const isBackorder =
      variant.inventory_management &&
      formatted?.inventory === 'none';

    if (isBackorder) {
      btn.textContent = 'Add to Backorder';
      btn.disabled = false;
    }
  };

  // force correct state after render
  setTimeout(() => {
    picker.updateAddToCartButton();
  }, 50);
}

function init() {
  const attach = () => {
    document.querySelectorAll('variant-picker').forEach(applyBackorder);
  };

  // initial run
  attach();

  // 🔥 key fix: watch for Symmetry re-creating components
  const observer = new MutationObserver(() => {
    attach();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

window.addEventListener('load', init);